'use strict';

import 'angular';
import {reverseUrl} from 'utils/django';

import '../call-selected-users/style.css';
import modalDirective from '../../rest-modal';
import template from '../call-selected-users/template.html';


export function callCustomSelectedUsersAPIV2Filter() {
	return function(activeDesignations) {
		if (!activeDesignations) return [];
		const retval = [];
		activeDesignations.forEach((designation) => {
			let profile = designation.active_profile;
			if (profile) {
				retval.push({
					uuid: profile.user.uuid,
					first_name: profile.user.first_name,
					last_name: profile.user.last_name,
					phone_number: profile.phone_number,
					custom_title: designation.name,
				});
			}
		});
		return retval;
	}
}


export default modalDirective({
	template: template,
	resolve: {
		users: resolveActiveUsersForIncident,
	},
	controller: controller,
});


function controller($scope) {
	'ngInject';

	$scope.selectedUsers = [];

	$scope.toggleUser = function(user) {
		var removed = false;
		for (var i = 0; i < $scope.selectedUsers.length; i++) {
			if ($scope.selectedUsers[i].uuid == user.uuid) {
				user.isSelected = false;
				removed = true;
				$scope.selectedUsers.splice(i--, 1);
			}
		}
		if (!removed) {
			$scope.selectedUsers.push(user);
			user.isSelected = true;
		}
		$scope.formattedUsers = $scope.selectedUsers.map(u => ({
			uuid: u.uuid,
			phone_number: u.phone_number,
		}))
		$scope.maxRounds = Math.ceil(2.1*$scope.selectedUsers.length);
	}
}


function resolveActiveUsersForIncident($incident, $context) {
	'ngInject';

	var users = [];
	var teamUUIDs = $incident.team.map(function(incidentUser) {
		return incidentUser.user.uuid;
	});
	for (let user of $context.users) {
		if (teamUUIDs.indexOf(user.uuid) == -1) {
			users.push(angular.copy(user));
		}
	}
	return users;
}
